enum IUserPayrollSettingFrequencies {
  weekly,
  monthly,
}

export default IUserPayrollSettingFrequencies;
